<script>
import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,
  props: ['labels', 'data', 'label'],
  data () {
    return {
      chartdata: {
        labels: this.labels,
        datasets: [
          {
            label: this.label,
            fontFamily: 'secondary-font, primary-font, segoe ui, tahoma',
            backgroundColor: ['#182C61', '#ff7675', '#0984e3', '#e17055', '#55efc4', '#2d3436', '#00b894', '#dfe6e9', '#d63031', '#a29bfe'],
            data: this.data
          }
        ]
      },
      options: {
        legend: {
          labels: {
            fontColor: 'primary-font segoe ui tahoma',
            fontFamily: 'secondary-font, primary-font, segoe ui, tahoma',
            fontSize: 15
          },
          data: {
            fontColor: 'red',
            fontFamily: 'secondary-font, primary-font, segoe ui, tahoma',
            fontSize: 15
          },
          default: 0
        },
        responsive: true,
        maintainAspectRatio: true
      }
    }
  },
  mounted () {
    this.renderChart(this.chartdata, this.options)
  }
}
</script>
